// extracted by mini-css-extract-plugin
module.exports = {"card":"SettingsCard_card__4ptxk","header":"SettingsCard_header__LUgib","description":"SettingsCard_description__1_bGX"};